"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var fragments_1 = require("./fragments");
var queryBodies = {
    alternativeProducts: "{title, products {" + fragments_1.productData + "}}",
    criteoProducts: "{title,  products {" + fragments_1.productData + "}}",
    lastSeenProducts: "{title, products {" + fragments_1.productData + "}}",
    outfit: "{title, products {" + fragments_1.productData + "}}",
    complementaryProducts: "{title, products {" + fragments_1.productData + "}}",
    similarProducts: "{title, products {" + fragments_1.productData + "}}",
    prudSysAddToBasket: "{title, products {" + fragments_1.productData + "}}",
    prudsysBasket: "{title, products {" + fragments_1.productData + "}, error}",
    prudsysCategoryToBrands: "{brands {" + fragments_1.brandData + "}, error}",
    prudsysCategoryToBrandsPapi: "{brands {" + fragments_1.brandData + "}, error}",
    prudsysCategoryToCategories: "{title, categories {" + fragments_1.categoryData + "}, error}",
    prudsysCategoryToCategoriesPapi: '{}',
    prudsysCategoryToProducts: "{title, products {" + fragments_1.productData + "}}",
    prudsysCategoryToProductsPapi: "{title, products {" + fragments_1.productData + "}}",
    prudsysHomePage: "{title, products {" + fragments_1.productData + "}}",
    prudSysProducts: "{title, extendedViewUrl, products {" + fragments_1.productData + "}}",
    prudSysProductsSimilar: "{title, products {" + fragments_1.productData + "}}",
    prudSysSearchTerm: "{title, products {" + fragments_1.productData + "}}",
    prudsysUserToProductsPapi: "{title, products {" + fragments_1.productData + "}}",
    seriesProducts: "{title, products {" + fragments_1.productData + "}}",
};
var buildQuery = function (queryName, queryParams) {
    var _a = Object.keys(queryParams).reduce(function (acc, p) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[p] = JSON.stringify(queryParams[p]), _a)));
    }, {}), id = _a.id, item = _a.item, pid = _a.pid, available = _a.available, brand = _a.brand, cid = _a.cid, locale = _a.locale, papibrands = _a.papibrands, papiproducts = _a.papiproducts, price = _a.price, productIds = _a.productIds, term = _a.term;
    var queryArgs = {
        alternativeProducts: "id: " + id + ", locale: " + locale,
        criteoProducts: "item: " + item + ", locale: " + locale + ", price: " + price + ", available: " + available,
        lastSeenProducts: '',
        outfit: '',
        similarProducts: "locale: " + locale + ", pid: " + pid,
        complementaryProducts: "locale: " + locale + ", pid: " + pid,
        prudSysAddToBasket: "cid: " + cid + ", pid: " + pid + ", brand: " + brand + ", locale: " + locale,
        prudsysBasket: "locale: " + locale + ", productIds: " + productIds,
        prudsysHomePage: "locale: " + locale,
        prudsysCategoryToBrands: "cid: " + cid + ", locale: " + locale,
        prudsysCategoryToBrandsPapi: "cid: " + cid + ", locale: " + locale + ", papibrands: " + papibrands,
        prudsysCategoryToCategories: "cid: " + cid + ", locale: " + locale,
        prudsysCategoryToCategoriesPapi: '',
        prudsysCategoryToProducts: "locale: " + locale + ", cid: " + cid,
        prudsysCategoryToProductsPapi: "locale: " + locale + ", cid: " + cid + ", papiproducts: " + papiproducts,
        prudSysProducts: "cid: " + cid + ", pid: " + pid + ", brand: " + brand + ", locale: " + locale,
        prudSysProductsSimilar: "cid: " + cid + ", pid: " + pid + ", brand: " + brand + ", locale: " + locale,
        prudSysSearchTerm: "term: " + term + ", locale: " + locale,
        prudsysUserToProductsPapi: "locale: " + locale + ", papiproducts: " + papiproducts,
        seriesProducts: "id: " + pid + ", locale: " + locale,
    };
    return queryName + "(" + queryArgs[queryName] + ")" + queryBodies[queryName];
};
exports.default = buildQuery;
//# sourceMappingURL=buildGraphQLQuery.js.map